// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  envName: 'production',
  production: true,
  hmr: false,
  baseUrl: 'https://www.myframeboard.com/',
  apiUrl: 'https://customerapi.myframeboard.com/api',
  defaultLogo: 'assets/images/essilor-logo-white.svg',
  userAccessURL: '/user/authenticate',
  notificationURL: '/notification',
  brandsURL: '/brands',
  image360Url: 'https://images.myframeboard.com/360/',
  mailjet: {
    tenant: 'MyFrameBoard',
    forgotPwTemplateId: 1391258,
    forgotPwSubject: 'MyFrameBoard.com - Forgot Password',
    forgotPwUrl: 'reset-password/',
    from: 'no-reply@myframeboard.com',
  },
  MSAL: {
    clientId: 'e7cdfa69-90ee-4585-95fd-c608bb8e60e7',
    redirectUri: 'https://myframeboard.com/catalog',
    logoutUri: 'https://myframeboard.com/login',
    authority:
      'https://nab2cprd.b2clogin.com/NAB2CPrd.onmicrosoft.com/B2C_1A_SIGNIN_FRAMEDREAMMULTITENANCY',
    scopes: ['openid', 'profile', 'e7cdfa69-90ee-4585-95fd-c608bb8e60e7'],
    knownAuthorities: ['nab2cprd.b2clogin.com'],
  },
  eceChatAPI:
    'https://ece.essilorusa.com/system/egain/chat/entrypoint/agentAvailability/1003',
  elasticApm: {
    enabled: false,
    serverUrl:
      'https://84db6f5e2b3144eeb6695e9e45618cba.apm.westeurope.azure.elastic-cloud.com:443',
  },
};
